import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import POSInterface from '../components/POSInterface';
import { POSTransaction } from '../types/pos';
import { message } from 'antd';

type POSView = 'cart' | 'stashed' | 'transactions';

const POS: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState<POSView>('cart');
  const [, setStashedCount] = useState(0); // Updated by POSInterface via onStashedCountUpdate

  // Determine view from URL path
  useEffect(() => {
    const path = location.pathname;
    if (path === '/pos') {
      // Redirect to cart view if on base POS path
      navigate('/pos/cart', { replace: true });
    } else if (path === '/pos/cart') {
      setCurrentView('cart');
    } else if (path === '/pos/stashed') {
      setCurrentView('stashed');
    } else if (path === '/pos/transactions') {
      setCurrentView('transactions');
    }
  }, [location.pathname, navigate]);

  // Handle POS transaction completion
  const handlePOSTransactionComplete = (transaction: POSTransaction) => {
    message.success(`Transaction ${transaction.transaction_number} completed successfully!`);
  };

  // Handle stashed count update from POSInterface
  const handleStashedCountUpdate = (count: number) => {
    setStashedCount(count);
  };

  // Handle view change - update URL
  const handleViewChange = (view: POSView) => {
    setCurrentView(view);
    if (view === 'cart') {
      navigate('/pos/cart');
    } else if (view === 'stashed') {
      navigate('/pos/stashed');
    } else if (view === 'transactions') {
      navigate('/pos/transactions');
    }
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      margin: 0,
      padding: 0
    }}>
      <div style={{ 
        flex: 1, 
        width: '100%', 
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <POSInterface 
          onTransactionComplete={handlePOSTransactionComplete}
          currentView={currentView}
          onViewChange={handleViewChange}
          onStashedCountUpdate={handleStashedCountUpdate}
        />
      </div>
    </div>
  );
};

export default POS;

